import { useEffect, useState } from 'react';

const ThumbnailVideo = (props: any) => {
  const [imageUrl, setImageUrl] = useState('');
  const { videoUrl, customClass } = props;

  const getImageUrl = (videoUrl: string) => {
    if (videoUrl && (videoUrl.includes('www.youtube.com') || videoUrl.includes('youtu.be'))) {
      const videoId = videoUrl.match(/(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?(?:.*&)?v=))([\w-]{11})(?:\S+)?$|^(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([\w-]+)/);
      
      if(videoUrl.includes("shorts")){
        if(videoId?.[2]){
          setImageUrl(`https://img.youtube.com/vi/${videoId?.[2]}/mqdefault.jpg`);
        }
      } else {
        if (videoId?.[1]) {
          setImageUrl(`https://img.youtube.com/vi/${videoId?.[1]}/mqdefault.jpg`);
        }
      }
    } else if (videoUrl && videoUrl.includes('vimeo.com')) {
      fetch(`https://vimeo.com/api/oembed.json?url=${videoUrl}`)
        .then((response) => response.json())
        .then((data) => {
          setImageUrl(data?.thumbnail_url);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    getImageUrl(videoUrl);
  }, []);

  return (
    <>
      {imageUrl ? (
        <img src={imageUrl} alt="" className={customClass ? customClass : ''} />
      ) : ''}
    </>
  );
};

export default ThumbnailVideo;
